<template>
    <div class="body d-flex py-lg-3 py-md-2">
        <div class="container-xxl mb-5">
            <div class="row clearfix">
                <div class="col-md-12">
                    <div class="card border-0 mb-2 no-bg">
                        <div
                            class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between main-button-area">
                            <div class="header-section">
                                <div class="search-area mt-2 d-flex align-items-center gap-2">
                                    <input id="main-search-input" type="search" class="form-control"
                                        placeholder="Αναζήτηση..." aria-label="search"
                                        aria-describedby="addon-wrapping" />
                                    <button class="btn wx-icon-btn" title="Φίλτρα" @click.prevent="searchClient">
                                        <i class="wx-ic wx-ic-sliders"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="d-flex mt-sm-0 mt-3 align-items-center gap-2">
                                <button class="btn wx-icon-btn" title="Export XLS" @click="exportXLS">
                                    <i class="wx-ic wx-ic-download"></i><span>XLS</span>
                                </button>
                                <button class="btn wx-icon-btn" title="Export PDF" @click="exportPDF">
                                    <i class="wx-ic wx-ic-download"></i><span>PDF</span>
                                </button>
                                <button type="button" class="ms-0 ms-sm-2 btn btn-dark" @click.prevent="createClient"
                                    v-if="canCreateContact || superUser">
                                    <i class="icofont-plus"></i>New contact
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row clearfix g-1">
                <div class="col-lg-12">
                    <div>
                        <div class="card-body table-responsive">
                            <Table :columns="columns" :data="data" :paginationLinks="paginationLinks"
                                :archiveContacts="archiveContacts" :tableOptions="tableOptions"
                                :isLinkColumn="isLinkColumn" :sortBy="sortBy" :refreshTable="fetchData"
                                :selected-columns="selectedColumns" , :filtersSearch="filtersSearch" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="create-client-form" tabindex="-1" aria-labelledby="createprojectlLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold" v-if="filterMode" id="filterContact">Φίλτρα</h5>
                        <h5 class="modal-title fw-bold" v-else id="createprojectlLabel">Στοιχεία επαφής</h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <input name="id" id="id" type="hidden" v-model="contactData.id" />

                        <div class="mb-3" v-if="!filterMode">
                            <label for="name" class="form-label">Name<sup>*</sup></label>
                            <input type="text" class="form-control" id="name" v-model="contactData.name"
                                placeholder="Name">
                        </div>
                        <div class="mb-3" v-if="!filterMode">
                            <label for="occupation" class="form-label">Occupation</label>
                            <input type="text" class="form-control" id="occupation" v-model="contactData.occupation"
                                placeholder="Occupation">
                        </div>
                        <div class="mb-3" v-if="!filterMode">
                            <label for="description" class="form-label">Description</label>
                            <input type="text" class="form-control" id="description" v-model="contactData.description"
                                placeholder="Description">
                        </div>
                        <div class="mb-3" v-if="!filterMode">
                            <label for="email" class="form-label">Email<sup>*</sup></label>
                            <input type="email" class="form-control" id="email" v-model="contactData.email"
                                placeholder="Email" required>
                        </div>
                        <div class="mb-3" v-if="!filterMode">
                            <label for="phone" class="form-label">Phone</label>
                            <input type="text" class="form-control" id="phone" v-model="contactData.phone"
                                placeholder="Phone">
                        </div>
                        <div class="mb-3" v-if="!filterMode">
                            <label for="address" class="form-label">Address</label>
                            <input type="text" class="form-control" id="address" v-model="contactData.address"
                                placeholder="Address">
                        </div>
                        <div class="mb-3" v-if="!filterMode">
                            <label for="postal" class="form-label">Postal code</label>
                            <input type="text" class="form-control" id="postal" v-model="contactData.postal"
                                placeholder="Postal">
                        </div>
                        <div class="mb-3" v-if="!filterMode">
                            <label for="afm" class="form-label">AFM</label>
                            <input type="text" class="form-control" id="afm" v-model="contactData.afm"
                                placeholder="AFM">
                        </div>
                        <div class="mb-3" v-if="filterMode">
                            <label for="name" class="form-label">Name</label>
                            <input type="text" class="form-control" id="name" v-model="filtersSearch.name"
                                placeholder="Name">
                        </div>
                        <div class="mb-3" v-if="filterMode">
                            <label for="occupation" class="form-label">Occupation</label>
                            <input type="text" class="form-control" id="occupation" v-model="filtersSearch.occupation"
                                placeholder="Occupation">
                        </div>
                        <div class="mb-3" v-if="filterMode">
                            <label for="email" class="form-label">Email</label>
                            <input type="email" class="form-control" id="email" v-model="filtersSearch.email"
                                placeholder="Email" required>
                        </div>

                        <div class="mb-3" v-if="filterMode">
                            <label for="phone" class="form-label">Phone</label>
                            <input type="text" class="form-control" id="phone" v-model="filtersSearch.phone"
                                placeholder="Phone">
                        </div>
                        <div class="mb-3" v-if="filterMode">
                            <label for="address" class="form-label">Address</label>
                            <input type="text" class="form-control" id="address" v-model="filtersSearch.address"
                                placeholder="Address">
                        </div>
                        <div class="mb-3" v-if="filterMode">
                            <label for="postal" class="form-label">Postal code</label>
                            <input type="text" class="form-control" id="postal" v-model="filtersSearch.postal"
                                placeholder="Postal">
                        </div>
                        <div class="mb-3" v-if="filterMode">
                            <label for="afm" class="form-label">AFM</label>
                            <input type="text" class="form-control" id="afm" v-model="filtersSearch.afm"
                                placeholder="AFM">
                        </div>

                        <div class="mb-3" v-if="filterMode">
                            <label class="form-label">Client</label>
                            <Select2 :options="allData2.clients" v-model="filtersSearch.clientId"
                                :settings="select2Settings" />
                        </div>
                        <div class="mb-3" v-if="filterMode">
                            <label class="form-label">Supplier</label>
                            <Select2 :options="allData2.suppliers" v-model="filtersSearch.supplierId"
                                :settings="select2Settings" />
                        </div>
                        <div class="mb-3" v-if="!filterMode">
                            <label class="form-label">Client</label>
                            <Select2 :options="allData.clients" v-model="contactData.clientId"
                                :settings="select2Settings" />
                        </div>
                        <div class="mb-3" v-if="!filterMode">
                            <label class="form-label">Supplier</label>
                            <Select2 :options="allData.suppliers" v-model="contactData.supplierId"
                                :settings="select2Settings" />
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" v-if="!filterMode" class="btn btn-secondary" @click="submitForm">Αποθήκευση</button>
<div v-if="filterMode" class="d-flex gap-2">
        <button type="button" class="btn btn-outline-secondary" style="background-color: transparent; color:black" @mouseover.stop
  @mouseenter.stop @click="clearFilters">Καθαρισμός φίλτρων</button>
        <button type="button" class="btn btn-secondary" @click="submitSearchForm">Αναζήτηση</button>
    </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed, reactive, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useFetchData } from '@/composables/useFetchData';
import { fetchAll, createOrUpdate, get, massArchiveContacts, getClientsServicesStatusesUsers, exportContactsXLS, exportContactsPDF } from '@/services/contacts-clients';
import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import Editor from '@tinymce/tinymce-vue';
import Select2 from 'vue3-select2-component';
import { mapGetters } from 'vuex';
import Table from '@/components/Table.vue';
import { nextTick } from 'vue';

const defaultcontactData = {
    id: '',
    description: '',
    name: '',
    email: '',
    phone: '',
    address: '',
    postal: '',
    occupation: '',
    afm: '',
    potential: '',
    foundUs: '',
    notes: '',
    paid: ''
};


export default {
    name: 'Contacts',
    components: {
        Editor,
        Select2,
        Table
    },
    methods: {

        canEditContact(contact) {
            if (!contact) { return false; }
            return localStorage.getItem('current_user_id') == contact?.createdBy && this.userPermissions?.edit === 1;
        },


    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission', // Add this line

        }),


        superUser() {
            return this.getSuperUserPermission === 1;
        },
        userPermissions() {
            return this.getUserPermission('Contacts');
        },

        canEditAllContacts() {
            return this.userPermissions?.editAll === 1;
        },
        canCreateContact() {
            return this.userPermissions?.create === 1;
        },
        canArchive() {
            return this.userPermissions?.archive === 1;
        },
    },
    setup() {
        const allData = ref({});
        const allData2 = ref({});

        const route = useRoute();
        const router = useRouter();

        const filterMode = ref(false);

        const { data, paginationLinks, filters, updateFilters, fetchData, sortBy } = useFetchData(fetchAll, { page: route.query.page || 1, active: 1, archived: 0 }, { page: 1, active: 1, archived: 0 },);

        const contactData = ref(defaultcontactData);
        const selectedClientIds = ref([]);
        const tableOptions = { path: 'contacts', singlePagePath: 'contact' };

        const filtersSearch = reactive({
            name: '',
            occupation: '',
            description: '',
            email: '',
            phone: '',
            address: '',
            postal: '',
            afm: '',
        });

        const selectedColumns = ref([
            "name",
            "clientSupplier",
            "phone",
            "email"
        ]);

        const columns = ref([
            { value: "name", label: "Name" },
            { value: "clientSupplier", label: "Client/Supplier" }, // ✅ combined column
            { value: "phone", label: "Phone" },
            { value: "email", label: "Email" },
            { value: "address", label: "Address" },
            { value: "postal", label: "Postal Code" },
            { value: "afm", label: "AFM" },
        ]);
        const isDropdownOpen = ref(false);

        const toggleClientSelection = (clientId, event) => {
            if (!selectedClientIds.value.includes(clientId)) {
                selectedClientIds.value.push(clientId);
            } else {
                selectedClientIds.value = selectedClientIds.value.filter(id => id !== clientId);
            }
        };

        watch(selectedColumns, (newVal) => {
            localStorage.setItem("selectedColumns", JSON.stringify(newVal));
        });

        const storedColumns = localStorage.getItem("selectedColumnsContacts");
        if (storedColumns) {
            selectedColumns.value = JSON.parse(storedColumns);
        }

        const filteredColumns = computed(() => selectedColumns.value);

        const toggleSelectAll = (event) => {
            if (Array.isArray(data.value)) { // Ensure `data.value` is an array
                if (event.target.checked) {
                    selectedClientIds.value = data.value.map(contact => contact.id); // Select all contact IDs
                } else {
                    selectedClientIds.value = []; // Clear all selections
                }
            } else {
                console.error('Expected data to be an array but got:', typeof data.value);
            }
        };

        const isAllSelected = computed(() => {
            return data.length > 0 && selectedClientIds.value.length === data.length;
        });


        const archiveContacts = async (selectedClientIds) => {
            if (!selectedClientIds.length) {
                useToast().error('Δεν έχετε επιλέξει επαφές');
                return;
            }
            const response = await massArchiveContacts({ ids: selectedClientIds });
            if (response.data.success) {
                useToast().success(response.data.message);
                fetchData();
            } else {
                useToast().error(response.data.message);
            }
        };

        const editClient = async (id) => {
            const tmpAllData = await getClientsServicesStatusesUsers();

            let newData = { clients: [], suppliers: [] };


            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.suppliers.length; i++) {
                newData.suppliers.push({ id: tmpAllData.data.suppliers[i].id, text: tmpAllData.data.suppliers[i].title });
            }
            allData.value = newData;

            const clientInfo = await get({ "id": id });
            if (clientInfo.data.success) {
                contactData.value.id = clientInfo.data.data.id;
                contactData.value.name = clientInfo.data.data.name;
                contactData.value.description = clientInfo.data.data.description;
                contactData.value.email = clientInfo.data.data.email;
                contactData.value.phone = clientInfo.data.data.phone;
                contactData.value.address = clientInfo.data.data.address;
                contactData.value.postal = clientInfo.data.data.postal;
                contactData.value.occupation = clientInfo.data.data.occupation;
                contactData.value.afm = clientInfo.data.data.afm;
                contactData.value.clientId = clientInfo.data.data.clientId;
                contactData.value.supplierId = clientInfo.data.data.supplierId;
                contactData.value.notes = clientInfo.data.data.notes;
                contactData.value.paid = clientInfo.data.data.paid;
            }
            $("#create-client-form").modal('toggle');
        };

        const createClient = async () => {
            filterMode.value = false;

            const tmpAllData = await getClientsServicesStatusesUsers();
            let newData = { clients: [], suppliers: [] };


            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.suppliers.length; i++) {
                newData.suppliers.push({ id: tmpAllData.data.suppliers[i].id, text: tmpAllData.data.suppliers[i].title });
            }
            allData.value = newData;




            contactData.value = {
                id: '',
                name: '',
                description: '',
                email: '',
                phone: '',
                address: '',
                postal: '',
                occupation: '',
                afm: '',
                potential: '',
                foundUs: '',
                notes: '',
                paid: '',
                supplierId: '',
                clientId: ''
            };
            $("#create-client-form").modal('toggle');
        };

        const searchClient = async () => {
            const tmpAllData = await getClientsServicesStatusesUsers();

            let newData = { clients: [], suppliers: [] };


            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.suppliers.length; i++) {
                newData.suppliers.push({ id: tmpAllData.data.suppliers[i].id, text: tmpAllData.data.suppliers[i].title });
            }
            allData2.value = newData;

            filterMode.value = true;

            await nextTick();
            $("#create-client-form").modal('toggle');

        };

        const submitForm = async () => {
            const response = await createOrUpdate(contactData.value);
            if (response.data.success) {
                useToast().success(response.data.message);
                $("#create-client-form").modal('toggle');

                // ✅ Apply filters when refreshing the table
                await fetchData({ ...filtersSearch, page: 1 });
            } else {
                useToast().error(
                    'Τα πεδία Name & Email είναι υποχρεωτικά. Ελέγξτε τα στοιχεία και προσπαθήστε ξανά.',
                    {
                        dangerouslyHTMLString: true
                    }
                );
            }
        };

        const exportPDF = async () => {
            const query = {};

            for (const [key, value] of Object.entries(filtersSearch)) {
                if (value !== '' && value !== null && value !== undefined && key !== 'value') {
                    query[`searchCriteria[${key}]`] = value;
                }
            }

            try {

                const response = await exportContactsPDF({ ...filters.value, ...query, columns });

                const blob = new Blob([response.data], { type: 'application/pdf' });

                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `ΑΝΑΖΗΤΗΣΗ_ΕΠΑΦΩΝ_${new Date().toLocaleDateString('el-GR').replace(/\//g, '_')}.pdf`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);

            } catch (error) {
                console.error('PDF export failed:', error);
                // Εμφάνιση toast αν έχεις
            }
        };


        const exportXLS = async () => {
            const query = {};
            for (const [key, value] of Object.entries(filtersSearch)) {
                if (value !== '' && value !== null && value !== undefined && key !== 'value') {
                    query[`searchCriteria[${key}]`] = value;
                }
            }

            try {
                const response = await exportContactsXLS({ ...filters.value, ...query, columns });

                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `ΑΝΑΖΗΤΗΣΗ_ΕΠΑΦΩΝ_${new Date().toLocaleDateString('el-GR').replace(/\//g, '_')}.xlsx`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);

            } catch (error) {
                console.error('Export XLS failed', error);
            }
        };


        const submitSearchForm = async () => {
            const query = {};
            for (const [key, value] of Object.entries(filtersSearch)) {
                if (value !== '' && value !== null && value !== undefined && key !== 'value') {

                    query[`searchCriteria[${key}]`] = value;
                }
            }


            await fetchData({ ...filters.value, ...query }); // trigger new fetch with formatted filters
            $('#client-filter').modal('hide');
            filterMode.value = false;
            $("#create-client-form").modal('toggle');
        };


        const getPageFromUrl = (url) => {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        };

        const closeMenu = (event) => {
            if (document.querySelector('.dropdown-menu').length && !document.querySelector('.dropdown-menu').contains(event.target) && !document.querySelector('.dropdown-menu-toggler').contains(event.target)) {
                isDropdownOpen.value = false;
            }
        };

        const clearFilters = () => {
            Object.keys(filtersSearch).forEach(key => {
                filtersSearch[key] = (key === 'clientId' || key === 'supplierId') ? null : '';
            });
        };


        const dropdownStyle = computed(() => ({
            top: isDropdownOpen.value ? '100%' : 'initial',
            right: isDropdownOpen.value ? '0' : 'initial'
        }));

        const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
        };

        const closeDropdown = () => {
            isDropdownOpen.value = false;
        };

        const select2Settings = {
            dropdownParent: '#create-client-form .modal-content',
            placeholder: "Please select",
            allowClear: true
        };

        const searchAction = () => {
            setTimeout(() => {
                router.push({ path: '/contacts', query: { ...route.query, search: $("#main-search-input").val() } });
            }, 300);
        };

        onMounted(() => {
            $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
            document.addEventListener('click', closeMenu);
        });

        onUnmounted(() => {
            $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
            document.removeEventListener('click', closeMenu);
        });

        const isLinkColumn = (value) => {
            return value == 'name' ? true : false;
        };

        return {
            isLinkColumn,
            tableOptions, columns, data, allData, allData2, paginationLinks, filters, filterMode, selectedColumns,filteredColumns, exportPDF, exportXLS, updateFilters, fetchData, getPageFromUrl, contactData, submitForm, editClient, createClient, selectedClientIds, toggleClientSelection, archiveContacts, dropdownStyle, closeDropdown, isDropdownOpen, toggleDropdown, select2Settings, sortBy, toggleSelectAll, searchClient, isAllSelected, submitSearchForm, filtersSearch
        };
    },
    metaInfo: {
        title: 'Επαφές',
        meta: [
            { name: 'description', content: 'MIS - Clients' },
            { property: 'og:title', content: 'MIS - Clients' },
            { property: 'og:description', content: 'This is the clients page.' }
        ]
    }
};
</script>

<style scoped>
.dropdown-menu.show {
    display: block;
}

tr.selected,
div.selected {
    background: #b1afaf;
}

#main-search-input {
    box-shadow: unset;
    margin-bottom: 10px;
}

#main-search-input::placeholder {
    color: #9BA9BF;
    font-weight: bold;
}

@media screen and (max-width: 48em) {
    .justify-content-between-mob{
        justify-content: space-between !important;
    }
}

</style>
